import { render } from "./VideoDetail.vue?vue&type=template&id=77d242ec"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"

import "./VideoDetail.vue?vue&type=style&index=0&id=77d242ec&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__